import saleMethods from './sale';
import fundialMethods from './fundial';
import generalMethods from './general';
import reporterMethods from './reporter';
import selfcareMethods from './selfcare';
import abroadMethods from './abroad';
import idfMethods from './idf';
import invoiceMethods from './invoice';

const providerMethods = Object.assign(
  {},
  saleMethods,
  fundialMethods,
  generalMethods,
  reporterMethods,
  selfcareMethods,
  abroadMethods,
  idfMethods,
  invoiceMethods
);

export default providerMethods;
